export const PauseCircleIcon = ({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_3177_443)">
      <path
        d="M6.33325 9.99998V5.99998M9.66659 9.99998V5.99998M14.6666 7.99998C14.6666 11.6819 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6819 1.33325 7.99998C1.33325 4.31808 4.31802 1.33331 7.99992 1.33331C11.6818 1.33331 14.6666 4.31808 14.6666 7.99998Z"
        stroke="#B54708"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </g>
    <defs>
      <clipPath id="clip0_3177_443">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
